import React, { useState } from 'react'
import './basic-checkbox.css'

export interface BasicCheckboxProps extends React.HTMLProps<HTMLInputElement>  { };

export function BasicCheckbox({id, label, checked, onChange, ...otherProps}: BasicCheckboxProps) {
  const defaultChecked = checked ? checked : false;
  const [isChecked, setIsChecked] = useState(defaultChecked) 
  return (
    <div className="basic-checkbox">
      <input
          {...otherProps}
          id = {id}
          type = "checkbox"
          checked={isChecked}
          onChange={(...args) => {
            setIsChecked((prev) => !prev)
            if (onChange) { onChange(...args) }
          }}
          className={isChecked ? 'checked' : ''}
        /> <label className='checkbox' htmlFor = {id}>{label}</label>
    </div>
  );
}
